import {
  Drawer,
  Box,
  IconButton,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PaymentModeResponse } from "@/app/classes/main";

const PaymentsTypeStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  border: "1px solid rgba(0, 0, 0, 0.2)",
  padding: "7px 1rem 7px 0px",
  borderRadius: "52px",
  margin: "0px 0px 1rem",
};

interface BottomDrawerProps {
  open: any;
  close: any;
  setPaymentMode: any;
  paymentMode: any;
  setPaymentModeName: any;
}

const BottomDrawer: React.FC<BottomDrawerProps> = ({
  open,
  close,
  setPaymentMode,
  paymentMode,
  setPaymentModeName,
}) => {
  const paymentModes: PaymentModeResponse[] = [];

  paymentModes.push(
    new PaymentModeResponse(
      "cod",
      2,
      "Pay After Service (Cash/Online/Wallet)",
      undefined,
      "",
      true,
      undefined,
      false,
      undefined,
      undefined,
      undefined
    )
  );

  paymentModes.push(
    new PaymentModeResponse(
      "card",
      1,
      "Credit/Debit Card",
      undefined,
      "credit-card.png",
      false,
      undefined,
      true,
      undefined,
      undefined,
      undefined
    )
  );

  paymentModes.push(
    new PaymentModeResponse(
      "upi",
      3,
      "UPI",
      undefined,
      "upi-new.png",
      false,
      undefined,
      true,
      undefined,
      undefined,
      undefined
    )
  );

  paymentModes.push(
    new PaymentModeResponse(
      "netbanking",
      4,
      "Net Banking",
      undefined,
      "bank-building.png",
      false,
      undefined,
      true,
      undefined,
      undefined,
      undefined
    )
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedName = event.target.getAttribute("name") || "";
    setPaymentMode(event.target.value);
    setPaymentModeName(selectedName);
    close();
  };

  return (
    <Drawer
      open={open}
      onClose={close}
      anchor="bottom"
      sx={{
        zIndex: 10000,
        "& .MuiDrawer-paper": {
          background: "#f5f5f5",
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px",
          width: "100%",
          padding: "1rem",
        },
      }}
      PaperProps={{
        sx: {
          height: "auto",
          padding: "1rem",
          maxWidth: "100%",
        },
      }}
      role="presentation"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
          Choose Payment Method
        </Typography>
        <IconButton onClick={close} sx={{ color: "black" }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue="female"
        name="radio-buttons-group"
        value={paymentMode}
        onChange={handleChange}
      >
        {paymentModes.map((item, i) => (
          <FormControlLabel
            key={i}
            sx={PaymentsTypeStyle}
            title={item?.name}
            value={item.code}
            control={<Radio size="small" name={item?.name} />}
            componentsProps={{
              typography: {
                component: "div",
                sx: {
                  width: "100%",
                  cursor: "pointer",
                },
              },
            }}
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography sx={{ marginLeft: "0px" }} variant="caption">
                  {item.name}
                </Typography>
              </Box>
            }
          />
        ))}
      </RadioGroup>
    </Drawer>
  );
};

interface PaymentMethodProps {
  drawerOpen: any;
  closeDrawer: any;
  setPaymentMode: any;
  paymentMode: any;
  setPaymentModeName: any;
}

const PaymentMethod: React.FC<PaymentMethodProps> = ({
  drawerOpen,
  closeDrawer,
  setPaymentMode,
  paymentMode,
  setPaymentModeName,
}) => {
  return (
    <div>
      <BottomDrawer
        open={drawerOpen}
        close={closeDrawer}
        setPaymentMode={setPaymentMode}
        paymentMode={paymentMode}
        setPaymentModeName={setPaymentModeName}
      />
    </div>
  );
};

export default PaymentMethod;
